module.exports = __webpack_public_path__ + "img/ico-calendar-active.3a5d2518.svg";